/**
 * Umbral por defecto de Early Access (Perrón Points) mientras el servicio no
 * conoce todavía el valor real del servidor (invitado sin sesión, o ningún
 * `/perron-points/me` ni 403 EA recibido aún). Espejo del default de
 * `early_access_min_balance` en `config/perron_points.php` (backend) — el
 * servidor sigue siendo la fuente autoritativa del gate; esto es solo el
 * texto que se muestra mientras tanto.
 */
export const PP_THRESHOLD_FALLBACK = 1000;
